import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "cards" }
const _hoisted_2 = { class: "cards__head" }
const _hoisted_3 = { class: "cards__body" }
const _hoisted_4 = { class: "cards__item" }
const _hoisted_5 = { class: "cards__head" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

import { ref } from 'vue'
import { ElPopconfirm } from 'element-plus'
import ContextMenu, { ContextMenuItem } from '@/components/ui/ContextMenu'

// Types
import { IdType } from '@/common/types'

// Data
import { useI18n } from 'vue-i18n'
import { useCommonStore } from '@/store'

export default /*#__PURE__*/_defineComponent({
  __name: 'Cards',
  emits: ["add", "delete", "setDefault"],
  setup(__props, { emit: __emit }) {

const index = ref<number>(0)

// i18n
const { t } = useI18n()

// Emits
const emit = __emit

// Store
const commonStore = useCommonStore()

// Methods
function setDefaultCard(id: IdType) {
  index.value++
  emit('setDefault', id)
}

function confirmEvent(id: IdType) {
  index.value++
  emit('delete', id)
}

return (_ctx: any,_cache: any) => {
  const _component_draw_svg = _resolveComponent("draw-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "cards__item cards__item_add",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('add')))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_draw_svg, {
          name: "add-card",
          width: "20",
          height: "20"
        })
      ]),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('cards.addNewCard')), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(commonStore).user?.cards, (card) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_draw_svg, {
            name: `${card.paymentSystem}-color`,
            width: "25",
            height: "25"
          }, null, 8, ["name"]),
          (!card.active)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(), _createBlock(_unref(ContextMenu), {
                  key: `ContextMenu-${card.id}-${index.value}`
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ContextMenuItem), {
                      onClick: ($event: any) => (setDefaultCard(card.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('cards.setDefault')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_unref(ElPopconfirm), {
                      onConfirm: ($event: any) => (confirmEvent(card.id)),
                      width: "210",
                      "hide-icon": "",
                      title: _ctx.$t('cards.confirm')
                    }, {
                      reference: _withCtx(() => [
                        _createVNode(_unref(ContextMenuItem), null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('cards.delete')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onConfirm", "title"])
                  ]),
                  _: 2
                }, 1024))
              ]))
            : _createCommentVNode("", true),
          (card.active)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_unref(ElPopconfirm), {
                  onConfirm: ($event: any) => (confirmEvent(card.id)),
                  width: "210",
                  "hide-icon": "",
                  title: _ctx.$t('cards.confirm')
                }, {
                  reference: _withCtx(() => [
                    _createVNode(_component_draw_svg, {
                      name: "delete",
                      width: "20",
                      height: "20"
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm", "title"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createTextVNode(" " + _toDisplayString(card.number) + " ", 1),
        (card.active)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" ∙ " + _toDisplayString(_ctx.$t('cards.isDefault')), 1)
            ], 64))
          : _createCommentVNode("", true)
      ]))
    }), 256))
  ]))
}
}

})